/**
  * An error handler which applies protected patient file response validation.
  */
class ForbiddenStatusCodeErrorHandler {
    /**
     * Handles a 403 error.
     * @param statusCode The status code, nothing happens if it's not 403.
     * @param message The error message that should be displayed.
     * @returns Returns true when an action is taken, false otherwise.
     */
    public static handleError(statusCode: number, message?: string): boolean {
        if (statusCode === 403
        && cacheStore.ClinicSettings.EnablePatientChartAllowlist
        && !IsNullOrWhiteSpace(message)) {
            sessionStore.showPopup({
                title: cacheStore.GetString("Allowlist_RestrictedAccessLabel"),
                content: message,
                showCancel: true,
                showOk: false,
                showCloseX: true
            });
            return true;
        }

        return false;
    }
}

export { ForbiddenStatusCodeErrorHandler };
